import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { DownloadsComponent } from './downloads/downloads.component';
import { OrderDetailsComponent } from '../orders/details/details.component';

import { AuthGuardService } from '../../core/services/auth/auth-guard.service';

export const downloadsRoutes: Routes = [
    {
        path: 'markiezen/downloads',
        component: DownloadsComponent,
        data: { type: 'markiezen' },
    },
    {
        path: 'kokers-en-profielen/downloads',
        component: DownloadsComponent,
        data: { type: 'kokers' },
    },
];

export const downloadsRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(downloadsRoutes);
